import React, { Component } from 'react'
import { makeObservable } from 'mobx'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import CheckboxCol from './CheckboxCol'
import CrossBreakSubQuestion from './CrossBreakSubQuestion'
import ENUM from '../ENUM'
import Select from '../../form/Select'
import Button from '../../../UniformComponents/Button'

@observer
class CrossBreakSlideConfig extends Component {
    constructor(props) {
        super(props)
        const { config } = this.props
        makeObservable(config.slide)
    }

    onKpiQuestionChange = ({ value }) => {
        const { config } = this.props
        const { slide } = config
        slide.kpiPageQuestionId = value
    }

    onComparisonChange = (_, { name, value }) => {
        const { config } = this.props
        const { slide } = config

        slide.comparisonSurveyIds = slide.comparisonSurveyIds.slice().map((comparison) => {
            if (comparison.value === name) {
                comparison.checked = value
            }
            return comparison
        })
    }

    onBenchmarkChange = (_, { name, value }) => {
        const { config } = this.props
        const { slide } = config

        slide.benchmarks = slide.benchmarks.slice().map((benchmark) => {
            if (benchmark.value === name) {
                benchmark.checked = value
            }
            return benchmark
        })
    }

    removeSubQuestion = (subQuestion) => {
        const { config } = this.props
        const { slide } = config

        slide.questions = slide.questions
            .slice()
            .filter(({ id }) => id !== subQuestion.id)
    }

    render() {
        const {
            config,
            config: {
                question: { questionTypeCode },
            },
            presentationStore,
        } = this.props
        const { kpiOptions } = presentationStore
        const { slide } = config
        const { comparisonSurveyIds, benchmarks, questions } = slide
        const questionOptions = presentationStore.getConfigFormOptions(questionTypeCode)

        return (
            <div style={{ width: '100%' }}>
                <div style={{ display: 'flex', marginBottom: '16px', alignItems: 'start' }}>
                    <div className="question-select-col" style={{ width: '40%', padding: 0 }}>
                        <Select
                            label={i18n.t('powerpoint.labels.kpi')}
                            options={kpiOptions}
                            onBlur={this.onKpiQuestionChange}
                            defaultValue={slide.kpiPageQuestionId}
                        />
                    </div>

                    {/* temporarily disabling comparison years */}
                    {/* <CheckboxCol
                        callback={this.onComparisonChange}
                        config={config}
                        title={i18n.t(`powerpoint.labels.${
                            questionOptions.filters
                                .find((item) => item.name === ENUM().comparisonSurveyIds).name}`)}
                        grid={{ xs: 6 }}
                        checkboxes={comparisonSurveyIds}
                        cssClass="checkbox-cols"
                    /> */}

                    <CheckboxCol
                        callback={this.onBenchmarkChange}
                        config={config}
                        title={
                            i18n.t(`powerpoint.labels.${questionOptions.filters
                                .find((item) => item.name === ENUM().benchmarks).name}`)
                        }
                        checkboxes={benchmarks}
                        cssClass="checkbox-cols"
                    />

                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 20 }}>
                    <div style={{ width: '100%' }}>
                        {
                            questions.map((subQuestion, i) => (
                                <div className="crossbreak-sub-question" key={subQuestion.id}>
                                    <CrossBreakSubQuestion
                                        subQuestion={subQuestion}
                                        removeSubQuestion={this.removeSubQuestion}
                                        crossBreakSubRankingOptions={slide.getRankingOptions()}
                                        index={i}
                                        presentationStore={presentationStore}
                                    />
                                </div>
                            ))
                        }
                        <div className="add-crossbreak-sub-question">
                            <Button
                                onClick={() => presentationStore.addSubQuestion(slide)}
                                cssClass="cross-break-sub-question-add"
                                icon="fa-light fa-circle-plus"
                                disabled={questions.length === presentationStore.crossBreakSubQuestionOptions.length}
                            >
                                {i18n.t('powerpoint.labels.addQuestion')}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

CrossBreakSlideConfig.propTypes = {
    config: PropTypes.object.isRequired,
    kpiOptions: PropTypes.array.isRequired,
    crossBreakSubQuestionOptions: PropTypes.array.isRequired,
}

export default CrossBreakSlideConfig
